import { localStorageGet } from "@/utils/localStorage";
import { LoginState } from "@/@types/vuex";

export default {
  isLoggedIn: false,
  roles: JSON.parse(localStorageGet("roles") || "[]") || [],
  token: localStorageGet("token") || "",
  user: { email: "" },
} as LoginState;
